<template>
  <member-header :pages="pages" :page-sizes="pageSizes" :num-items="count" @search="search" />
  <div v-if="isLoading" class="table-responsive">
    <div class="loadingSpinner">
      <i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
      <span>loading...</span>
    </div>
  </div>
  <div v-else class="table-responsive">
    <div class="custom-listing" :style="listingHeight">
      <z-table v-model="records" class="table table-bordered table-striped" :is-single-row-detail="true"
        :is-header-fixed="isHeaderFixed" :sort-by="sortBy" :order-by="orderBy" :columns="tableColumnsName"
        :detail-column-class="detailColumnClass" :loading="isLoading" @sort="setOrder">
        <template #tbody="props">
          <th scope="row" class="custom-column-60 text-center">
            <input v-if="isAdmin" @input="(event) => memberChecked(event.target.checked, props.row)" type="checkbox"
              :checked="props.row.checked" :id="props.row.firmFirm" class="custom-checkbox" />
          </th>
          <td class="custom-column-160">{{ props.row.estimatingId }}</td>
          <td v-if="isDashboard">
            <a href="#" @click="gotoLocation(props.row)">{{ props.row.firmName }}</a>
          </td>
          <td v-else>{{ props.row.firmName }}</td>
          <td v-if="!isDashboard" class="text-center" :class="{ 'custom-optin': props.row.isOptIn }">
            {{ setOptIn(props.row.isOptIn) }}
          </td>
          <td v-if="!isDashboard" class="custom-column-180">{{ formatDate(props.row.optInOn) }}</td>
          <td v-if="isAdmin && !isDashboard" class="custom-column-250">
            <select v-model="props.row.parent" class="form-control" @change="selectedLocation(props.row)">
              <option v-for="location in associations" :key="location.id" :value="location.id">
                {{ location.name }}
              </option>
            </select>
          </td>
          <td v-else-if="!isDashboard" class="custom-column-250">{{ props.row.parentName }}</td>
          <td v-if="!isDashboard" class="custom-column-140">{{ setSource(props.row.source) }}</td>
        </template>
        <template #detail="props">
          <member-detail :firm="props.row" />
        </template>
        <template #empty> Nothing found! </template>
      </z-table>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { locationStore } from '@/stores/location'
import { lookupStore } from '@/stores/lookup'
import { dashboardStore } from '@/stores/dashboard'
import router from '@/router'
import globals from '@/plugins/globals'
import ZTable from '@/components/utilities/elements/Table.vue'
import MemberHeader from './MemberHeader.vue'
import MemberDetail from './forms/MemberDetail.vue'
export default {
  name: 'MemberListing',
  components: {
    ZTable,
    MemberHeader,
    MemberDetail
  },
  props: {
    firm: Object,
    isDashboard: {
      type: Boolean,
      default: false
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    listingHeight: String
  },
  data() {
    return {
      isHeaderFixed: true,
      page: 1,
      pageSizes: [
        { name: '10', value: 10 },
        { name: '25', value: 25 },
        { name: '50', value: 50 },
        { name: '100', value: 100 }
      ],
      detailColumnClass: 'custom-column-60',
      checkedItems: []
    }
  },
  async mounted() {
    this.page = 1
    this.setListParam({
      name: 'page',
      value: this.page
    })
    // await this.search()
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(locationStore, ['loading', 'listParams', 'members', 'locations']),
    ...mapState(dashboardStore, ['selectedInsurer', 'totalInspections']),
    count() {
      let _count = 0
      if (this.members) {
        _count = this.members.count
      }
      return _count
    },
    isAdmin() {
      let _is = false
      if (this.firm && [1, 2, 3].includes(this.profile.roles[0])) {
        _is = this.firm.type === 'Corporate'
      }
      return _is
    },
    records() {
      let _records = []
      if (this.members) {
        if (this.members.items) {
          _records = this.members.items
        }
      }
      return _records
    },
    tableColumnsName() {
      let columns = [
        {
          field: 'firmFirm',
          label: '',
          sortable: false,
          class: 'custom-column-60'
        },
        {
          field: 'estimatingId',
          label: 'Estimating Id',
          sortable: true,
          class: 'custom-column-160 text-center'
        },
        { field: 'firmName', label: 'Shop', sortable: true }
      ]
      if (!this.isDashboard) {
        columns = columns.concat([
          {
            field: 'isOptIn',
            label: 'Opt In?',
            sortable: false,
            class: 'text-center custom-column-80'
          },
          {
            field: 'optInOn',
            label: 'Opt In Changed',
            sortable: true,
            class: 'custom-column-180 text-center'
          },
          { field: 'parent', label: 'Associated with', sortable: false, class: 'custom-column-250' },
          { field: 'source', label: 'Source', sortable: true, class: 'custom-column-140' }
        ])
      }
      return columns
    },
    pages() {
      let _pages = 0
      if (this.members) {
        _pages = Math.ceil(this.members.count / this.listParams.pageSize)
      }
      return _pages
    },
    sortBy() {
      return this.listParams.sortBy
    },
    orderBy() {
      return this.listParams.orderBy
    },
    isLoading() {
      return this.loading.members
    },
    associations() {
      let _associations = [
        {
          id: -1,
          name: 'None'
        }
      ]
      if (this.locations) {
        _associations = _associations.concat(this.locations)
      }
      console.log('Associations', _associations)
      return _associations
    }
  },
  methods: {
    ...mapActions(lookupStore, ['getLookups']),
    ...mapActions(locationStore, ['setListParam', 'paginate', 'getMembers', 'saveMemberParent', 'setMember']),
    ...mapActions(dashboardStore, ['setFirm', 'getTotals']),
    formatDate(date, type = 'datetime') {
      return globals.formatDate(date, type)
    },
    setOptIn(value) {
      return value ? 'Yes' : 'No'
    },
    setSource(value) {
      if (value.substring(0, 4) === 'ADAS') {
        return 'ADAS Map'
      } else if (value.substring(0, 9) === 'Calibrate') {
        return 'Mobile Copilot'
      } else if (value.substring(0, 9) === 'TestDrive') {
        return 'Test Drive Copilot'
      } else {
        return value
      }
    },
    memberChecked(event, row) {
      this.$nextTick(() => {
        this.setMember({
          name: 'checked',
          firmFirm: row.firmFirm,
          checked: event
        })
      })
    },
    async selectedLocation(row) {
      console.log('Selected Location', row)
      await this.saveMemberParent({
        firmFirm: row.firmFirm,
        parent: row.parent
      })
    },
    async setOrder(column, sortBy) {
      this.page = 1
      this.setListParam({
        name: 'sortBy',
        value: sortBy
      })
      this.setListParam({
        name: 'orderBy',
        value: column.field
      })
      await this.search(this.page, this.searchTerm)
    },
    async search(page = 1, searchTerm) {
      // Load up the Members
      try {
        console.log('Search Members', {
          firm: this.firm,
          selectedInsurer: this.selectedInsurer
        })

        if (searchTerm !== '' && searchTerm !== null) {
          this.page = 1
        } else {
          this.page = page
        }
        await this.getMembers({
          firm: this.selectedInsurer && this.isDashboard ? this.selectedInsurer : this.firm.firm,
          page: this.page,
          offset: (this.page - 1) * this.listParams.pageSize,
          sortBy: this.listParams.sortBy,
          orderBy: this.listParams.orderBy,
          pageSize: this.listParams.pageSize,
          searchTerm: this.listParams.searchTerm,
          type: this.listParams.filterBy,
          filter: this.firm.type === 'Corporate' ? 'root' : null
        })
      } catch (e) {
        console.log('Error', e)
      }
    },
    async gotoLocation(row) {
      console.log('Goto Location', {
        row: row,
        selectedInsurer: this.selectedInsurer,
        shopCardData: this.shopCardData,
        tableDetails: this.tableDetails
      })
      this.setFirm({
        firm: row.id,
        name: row.firmName,
        source: row.source
      })
      // if (this.totalInspections === 0) {
      //   await this.getTotals(this.selectedInsurer)
      // }
      router.push(`/repairNetwork/${row.firm}`)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-listing {
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  max-height: 580px;
  height: 580px;
}

.custom-header {
  position: sticky;
  top: 0;
}

.custom-optin {
  color: green;
  font-weight: 600;
}
</style>
